import { PluginMedia } from 'rwl-shared/dist/models/plugin/Plugin';

export const removeDuplicateMedia = (mediaArray: PluginMedia[]) => {
    return mediaArray.reduce(function (acc: PluginMedia[], curr: PluginMedia) {
        if (!acc.find((item) => item.id === curr.id)) {
            acc.push(curr);
        }
        return acc;
    }, []);
};
